export default __webpack_public_path__ + "static/media/shape.30a87966.svg";